// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1beL-","index":"styles_index__3ZVea"};